
export const value_replace_zero = true
export const value_zero_replacement = "/"
